import { render, staticRenderFns } from "./StarCount.vue?vue&type=template&id=386ce6c9&scoped=true"
import script from "./StarCount.vue?vue&type=script&lang=js"
export * from "./StarCount.vue?vue&type=script&lang=js"
import style0 from "./StarCount.vue?vue&type=style&index=0&id=386ce6c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ce6c9",
  null
  
)

export default component.exports